import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/reddit': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M201.5 305.5C187.7 305.5 176.6 294.4 176.6 280.9 176.6 267.1 187.7 256 201.5 256 215.1 256 226.1 267.1 226.1 280.9 226.1 294.5 215 305.5 201.5 305.5zM504 256C504 393 393 504 256 504S8 393 8 256 119 8 256 8 504 119 504 256zM371.7 214.8C362.3 214.8 354 218.7 347.9 224.8 325.5 209.3 295.3 199.3 261.8 198.2L279.2 119.9 334.6 132.4C334.6 146 345.7 157 359.2 157 373 157 384.1 145.7 384.1 132.1S373 107.2 359.2 107.2C349.5 107.2 341.2 113 337.1 121L275.9 107.4C272.9 106.6 269.8 108.8 269 111.8L249.9 198.2C216.7 199.6 186.8 209.5 164.4 225 158.3 218.6 149.7 214.8 140.3 214.8 105.4 214.8 94 261.7 125.9 277.6 124.8 282.6 124.2 287.8 124.2 293.1 124.2 345.7 183.4 388.3 256.2 388.3 329.3 388.3 388.5 345.7 388.5 293.1 388.5 287.8 387.9 282.3 386.6 277.3 417.9 261.3 406.4 214.8 371.7 214.8zM302.8 331C284.6 349.2 226.7 348.9 209.2 331 207 328.8 203.1 328.8 200.9 331 198.4 333.5 198.4 337.4 200.9 339.6 223.7 362.4 288.2 362.4 311.1 339.6 313.6 337.4 313.6 333.5 311.1 331 308.9 328.8 305 328.8 302.8 331zM310.5 256C296.9 256 285.9 267.1 285.9 280.9 285.9 294.5 297 305.5 310.5 305.5 324.3 305.5 335.4 294.4 335.4 280.9 335.4 267.1 324.4 256 310.5 256z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/reddit.js
// module id = fq6i
// module chunks = 144